import { Animated } from 'react-native'
import styled from 'styled-components/native'

import BottomSheet from 'APP/Components/BottomSheet'

import { ApplicationStyles } from 'APP/Themes'

export const StyledBottomSheet = styled(BottomSheet)`
  ${ApplicationStyles.shadow};
  border-radius: 20px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
`

export const Header = styled.View`
  position: relative;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.elementsBg};
  border-radius: 20px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  padding-top: ${({ theme }) => theme.metrics.baseMargin * 1.5}px;
  padding-bottom: ${({ theme }) => theme.metrics.baseMargin * 1.5}px
  padding-horizontal: ${({ theme }) => theme.metrics.baseMargin * 1.5}px;
`

export const Title = styled.View`
  align-items: center;
`

export const HeaderButtonWrapper = styled(Animated.View)`
  position: absolute;
  top: 0;
  right: ${({ theme }) => theme.metrics.baseMargin * 1.5}px;
  bottom: 0;
  justify-content: center;
  align-items: center;
  flex-grow: 0;
`

export const HeaderButton = styled.View`
  width: 25px;
  height: 25px;
`
